import axios from 'axios';
import { setAlert } from "./alert";

import { url } from '../utils/api';
import { ADD_IMAGE, DELETE_IMAGE, GALLERY_ERROR, LOAD_GALLERY } from './types';

// Get rooms
export const loadGallery = () => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.get(`${url}/api/gallery`, config);
  
          dispatch({
              type: LOAD_GALLERY,
              payload: res.data
          });
      } catch (err) {
          dispatch({
              type: GALLERY_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
      }
  }
  
// Add Image
export const addImage = (formData, navigate) => async dispatch => {
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      try {
          const res = await axios.post(`${url}/api/gallery/add`, formData, config);
  
          dispatch({
              type: ADD_IMAGE,
              payload: res.data
          });
  
          dispatch(setAlert('Added a new image', 'success'));
          navigate('/adminDashboard/gallery');
      } catch (err) {
          dispatch(setAlert('Error uploading image', 'danger'));
          dispatch({
              type: GALLERY_ERROR,
              payload: { msg: err.response.statusText, status: err.response.status}
          });
          
      }
}

// Delete Image
export const deleteImage = (_id, navigate) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
        }
    }
    if(window.confirm('Are you sure about deleting this image? This can NOT be undone!')) {
        try {
            await axios.delete(`${url}/api/gallery/${_id}`, config);

            dispatch({
                type: DELETE_IMAGE,
                payload: _id
            });
            navigate('/adminDashboard/gallery');
            dispatch(setAlert('Image Deleted', 'success'));
        } catch (err) {
            dispatch({
                type: GALLERY_ERROR,
                payload: { msg: err.response.statusText, status: err.response.status}
            });
        }
    }
};
